import styled, { createGlobalStyle } from 'styled-components';
import { TextField } from '@material-ui/core';

export const CadastroGlobalStyle = createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html,
  body,
  #root {
    width: 100%;
    min-width: 0;
    min-height: 100%;
    height: auto;

    margin: 0;
    padding: 0;
  }

  html {
    overflow-x: hidden;
    overflow-y: auto;
  }

  body {
    overflow-x: hidden !important;
    overflow-y: auto !important;
  }

  #root {
    overflow: visible !important;
  }
`;

export const Base = styled.div`
  display: flex;

  width: 100%;
  min-width: 0;
  min-height: 100dvh;

  overflow-x: hidden;
  overflow-y: visible;

  @media (max-width: 768px) {
    flex-direction: column;

    width: 100%;
    height: auto;
    min-height: 100dvh;

    overflow: visible;
  }
`;

export const Lateral = styled.div`
  flex: 0 0 25%;
  min-height: 100dvh;
  
background: linear-gradient(
  160deg,
  #2a3176 0%,
  #232967 100%
);

  text-align: center;
  border-radius: 0 28px 28px 0;
  box-shadow: 8px 0 24px rgba(42, 49, 118, 0.12);
  position: relative;
&::after {
  content: "";
  position: absolute;
  width: 280px;
  height: 280px;
  right: -120px;
  bottom: -100px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.04);
}
& > * {
  position: relative;
  z-index: 1;
}
  @media (max-width: 1100px) {
    flex-basis: 20%;
  }

  @media (max-width: 900px) {
    flex-basis: 18%;
    border-radius: 0 22px 22px 0;
  }

  @media (max-width: 768px) {
    flex: none;
    width: 100%;
    min-height: auto;
    border-radius: 0 0 22px 22px;
    box-shadow: 0 6px 20px rgba(42, 49, 118, 0.12);
  }
`;

export const Logo = styled.img`
  display: block;

  width: min(80%, 426px);
  height: auto;

  margin: clamp(15px, 6vh, 40px) auto 0;

  @media (max-width: 768px) {
    width: min(55%, 220px);
    margin-top: 10px;
  }

  @media (max-width: 400px) {
    width: min(35%, 150px);
  }
`;

export const TextPosition = styled.div`
  margin: clamp(10px, 4vw, 50px);
  padding: 20px;

  text-align: left;

  @media (max-width: 900px) {
    margin: 10px 15px;
  }

  @media (max-width: 768px) {
    margin: 12px 8px 0;
    padding: 0;
    text-align: center;
  }
`;

export const TextWelcome = styled.h4`
  font-family: "Open Sans", sans-serif;
  font-weight: 700;

  color: #ffffff;
  @media (max-width: 900px) {
    font-size: 16px;
  }

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

export const CadastroDescription = styled.p`
  margin-top: 10px;
  font-weight: 400;
  line-height: 1.5;
  color: #ffffff;
  @media (max-width: 768px) {
    margin-top: 6px;
    font-weight: normal;
  }
`;

export const CadastroMain = styled.div`
  flex: 1;

  min-width: 0;
  min-height: 100dvh;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  padding: 60px 30px 40px;

  background-color: #ffffff;

  @media (max-width: 768px) {
    flex: none;

    width: 100%;
    min-width: 0;
    min-height: auto;
    height: auto;

    padding: 24px 20px 30px;
  }

  @media (max-width: 400px) {
    padding: 10px 8px 20px;
  }
`;

export const CadastroContainer = styled.div`
  width: min(100%, 680px);
`;

export const CadastroTitle = styled.h2`
  margin: 0;
  text-align: left;
  font-size: 26px;
  font-weight: 700;
  color: #41b490;
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const CadastroSubtitle = styled.p`
  text-align: left;
  font-size: 16px;
  color: #666666;
  font-weight: 550;

  @media (max-width: 768px) {
    margin-bottom: 18px;
  }

  @media (max-width: 400px) {
    font-size: 13px;
  }
`;

export const CadastroForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 400px) {
    gap: 10px;
  }
`;

export const CadastroTextField = styled(TextField)`
  .MuiInputBase-input {
    font-size: 14px;
  }

  .MuiInputLabel-root {
    font-size: 14px;
  }

  .MuiOutlinedInput-input {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .MuiFormHelperText-root {
    font-size: 11px;
  }

  @media (max-width: 400px) {
    .MuiInputBase-input {
      font-size: 13px;
    }

    .MuiInputLabel-root {
      font-size: 13px;
    }

    .MuiOutlinedInput-input {
      padding-top: 13px;
      padding-bottom: 13px;
    }
  }
`;
export const CadastroDadosRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

export const TermoArea = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 8px;
`;

export const TermoLink = styled.button`
  margin: 0;
  padding: 0;

  border: 0;

  background: transparent;

  font-family: inherit;
  font-size: inherit;
  font-weight: 700;

  color: #005d9f;

  text-decoration: underline;

  cursor: pointer;

  &:hover {
    color: #41b490;
  }
`;

export const TermoError = styled.span`
  margin-top: -4px;
  margin-left: 32px;

  font-size: 12px;

  color: #f44336;
`;

export const CadastroButton = styled.div`
  display: flex;
  justify-content: center;

  margin-top: 8px;

  button {
    width: min(100%, 300px);
  }

  @media (max-width: 768px) {
    button {
      width: 100%;
    }
  }
`;

export const TermoContent = styled.div`
  font-size: 14px;
  line-height: 1.2;

  color: #444444;
`;

export const TermoActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  width: 100%;
  min-width: 0;
  gap: 12px;
  padding: 16px 24px;

  button {
    min-width: 110px;
    text-transform: none;
    font-weight: 600;
  }

  button:last-child {
    background-color: #41b490;
    color: #ffffff;

    &:hover {
      background-color: #329977;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: stretch;

    gap: 10px;
    padding: 16px;

    button {
      width: 100%;
      min-width: 0;
      min-height: 42px;
      margin: 0;
    }
  }
`;